import { Typography, FAIcon } from "@sgi/gravity";
import { Box, Flex, Center } from "@chakra-ui/react";
import { faEnvelope, faPhone } from "@fortawesome/pro-solid-svg-icons";
import { useWrapper } from "../Context/WrapperContext";
import ButtonLink from "../Components/ButtonLink";

export default function CustomerService() {
  const { decrement } = useWrapper();

  return (
    <Box
      style={{
        position: "relative",
        maxWidth: "64vw",
      }}
      data-testid="customerservice-test"
      overflow="hidden"
    >
      <Flex
        direction="column"
        maxW={350}
        height={"100vh"}
        mx="auto"
        alignContent={"center"}
        justifyContent={"center"}
      >
        <Typography variant="h2">Customer service</Typography>
        <Box
          style={{ zIndex: "200", position: "relative", paddingTop: "10px" }}
          data-testid="customerservice-inside-test"
        >
          <Typography variant="body" mb={8}>
            Please call your Broker or you can reach us at
          </Typography>
          <Flex flexDirection="row" style={{ paddingBottom: "20px" }}>
            <FAIcon
              icon={faEnvelope}
              style={{ paddingRight: "20px" }}
              size="3xl"
            />
            sgiinquiries@sgi.sk.ca
          </Flex>
          <Flex flexDirection="row" style={{ paddingBottom: "20px" }}>
            <FAIcon
              icon={faPhone}
              style={{ paddingRight: "20px" }}
              size="3xl"
            />
            1-844-TLK-2SGI (1-844-855-2744)
          </Flex>
          <Center>
            <Typography
              className="custom-link"
              variant="bodyBold"
              color="teal.500"
            >
              <ButtonLink linkCaption="Back" handleClick={decrement} />
            </Typography>
          </Center>
        </Box>
      </Flex>
    </Box>
  );
}
